import { AxiosInstance } from 'axios'
import { IExportResponse } from '../../../types/importExport.types'

interface IConceptExportRequest {
  topics: {
    global_concept_id: string,
    label: string
  } []
}

export function topicsExportApiFactory(api: AxiosInstance) {
  const baseUrl = '/api/v1/export/topic-content'

  const methods = {
    getAll() {
      return api.get<IExportResponse[]>(`${baseUrl}`)
    },
    getExport(exportId: number) {
      return api.get<IExportResponse>(`${baseUrl}/${exportId}`)
    },
    triggerExport(payload: IConceptExportRequest) {
      return api.post<IExportResponse>(baseUrl, payload)
    },
    async getDownloadLink(exportId: number, filename: string): Promise<HTMLAnchorElement | undefined> {
      return api.get(`${baseUrl}/${exportId}/file`, {
        responseType: 'blob'
      }).then((response) => {
        const blob = new Blob([ response.data ], { type: 'text/csv' })
        const downloadLink = document.createElement('a')
        downloadLink.href = URL.createObjectURL(blob)
        downloadLink.download = filename
        return downloadLink
      })
    }
  }
  return methods
}
